const HEARTBEAT_INTERVAL_MS = 60_000
const HEARTBEAT_TIMER_KEY = '__imhere_heartbeat_timer__'

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined' || window.Cypress) {
    return
  }

  const { $posthog } = useNuxtApp()
  const isTabActive = (): boolean => document.visibilityState === 'visible'

  const ping = async (): Promise<void> => {
    if (!isTabActive()) {
      return
    }

    try {
      $posthog?.capture?.('imhere', {
        path: window.location.pathname
      })
    } catch {
      // Best-effort analytics.
    }

    try {
      await fetch('/api/imhere', {
        method: 'GET',
        credentials: 'include'
      })
    } catch {
      // Best-effort heartbeat.
    }
  }

  const existingTimer = (window as Window & { [HEARTBEAT_TIMER_KEY]?: number })[HEARTBEAT_TIMER_KEY]
  if (existingTimer) {
    window.clearInterval(existingTimer)
  }

  void ping()

  const timer = window.setInterval(() => {
    ping()
  }, HEARTBEAT_INTERVAL_MS)

  ;(window as Window & { [HEARTBEAT_TIMER_KEY]?: number })[HEARTBEAT_TIMER_KEY] = timer
})
